import region from '../utils/region.js'

import {SVERD, ORENB, ORLOV, HMAO, KRASN, KALUG, KAREL, SAAS, TATAR, MARIEL, KURGAN, CHUVA, BURYATIA, CHECHNYA, YANAO, CRIMEA, KURSK, PSCOV} from '../config/region.js'
import {
  GARBAGE_TYPE_COUNTRY_COMM,
  GARBAGE_TYPE_DEFENCE,
  GARBAGE_TYPE_GARAGE,
  GARBAGE_TYPE_INDIVIDUAL,
  GARBAGE_TYPE_INDIVIDUAL_AREA,
  GARBAGE_TYPE_LEGAL_ENTITY,
  GARBAGE_TYPE_MANAGER,
  GARBAGE_TYPE_MEDIC,
  GARBAGE_TYPE_MKD,
  GARBAGE_TYPE_ORGANIZATION,
  GARBAGE_TYPE_SETTLEMENT
} from './config'

let _MAP = {
  default: {
    center: [0, 0],
    zoom: 6,
    minZoom: 4
  },
  [SVERD]: {
    center: [58.91599192355906, 65.80810546875001],
    zoom: 6,
    minZoom: 4
  },
  [ORENB]: {
    center: [51.730430542940184, 56.05224609375001],
    zoom: 7,
    minZoom: 4
  },
  [ORLOV]: {
    center: [52.7113393283508, 36.82067871093751],
    zoom: 8,
    minZoom: 4
  },
  [HMAO]: {
    center: [62.31900278603092, 73.23486328125001],
    zoom: 6,
    minZoom: 4
  },
  [KRASN]: {
    center: [45.359865333959746, 39.07836914062501],
    zoom: 7,
    minZoom: 4
  },
  [KALUG]: {
    center: [54.3197273165176, 35.60394287109376],
    zoom: 8,
    minZoom: 4
  },
  [KAREL]: {
    center: [64.0096821891768, 36.06811523437501],
    zoom: 6,
    minZoom: 4
  },
  [SAAS]: {
    center: [65.80277639340238, 102.34863281250001],
    zoom: 4,
    minZoom: 4
  },
  [TATAR]: {
    center: [54.942921113078356,51.7236328125],
    zoom: 7,
    minZoom: 7
  },
  [MARIEL]: {
    center: [56.64879257851124,48.45093047163649],
    zoom: 8,
    minZoom: 4
  },
  [KURGAN]: {
    center: [55.48378145808743,66.15965611075386],
    zoom: 7,
    minZoom: 4
  },
  [CHUVA]: {
    center: [55.455498798971156,47.97180175781251],
    zoom: 8,
    minZoom: 4
  },
  [BURYATIA]:{
    center: [53.60950465,111.027100878386],
    zoom: 6,
    minZoom: 4
  },
  [CHECHNYA]:{
    center: [43.26320625445309,46.0711669921875],
    zoom: 9,
    minZoom: 4
  },
  [YANAO]:{
    center:  [67.1471631,74.3415488],
    zoom: 5,
    minZoom: 4
  },
  [CRIMEA]:{
    center: [45.47361429775641,34.96948242187501],
    zoom: 8,
    minZoom: 4,
  },
  [KURSK]:{
    center: [51.687882310357594,36.94702148437501],
    zoom: 8,
    minZoom: 4,
  },
  [PSCOV]:{
    center: [57.38578314962142,30.772705078125],
    zoom: 7,
    minZoom: 4,
  }
}

export const MAP = region.getRegionConfig(_MAP)

export let TILE_LAYER = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'

export let POPUP_AUTO_PAN = false
export let POPUP_KEEP_IN_VIEW = false

let _GARBAGE_TYPE_ROUTE_NAME_MAP = {
  default: {
    [GARBAGE_TYPE_MANAGER]: 'geo.objects.manager.update',
    [GARBAGE_TYPE_COUNTRY_COMM]: 'geo.objects.countryCommunity.update',
    [GARBAGE_TYPE_SETTLEMENT]: 'geo.objects.settlement.update',
    [GARBAGE_TYPE_DEFENCE]: 'geo.objects.defense.update',
    [GARBAGE_TYPE_GARAGE]: 'geo.objects.garage.update',
    [GARBAGE_TYPE_INDIVIDUAL_AREA]: 'geo.objects.individualArea.update',
    [GARBAGE_TYPE_INDIVIDUAL]: 'geo.objects.individual.update',
    [GARBAGE_TYPE_LEGAL_ENTITY]: 'geo.objects.legalEntity.update',
    [GARBAGE_TYPE_MEDIC]: 'geo.objects.medic.update',
    [GARBAGE_TYPE_ORGANIZATION]: 'geo.objects.organization.update',
    [GARBAGE_TYPE_MKD]: 'geo.objects.apartmentBuildings.update'
  },
  [KRASN]: {
    [GARBAGE_TYPE_MANAGER]: 'geo.objects.manager.update',
    [GARBAGE_TYPE_COUNTRY_COMM]: 'geo.objects.countryCommunity.update',
    [GARBAGE_TYPE_SETTLEMENT]: 'geo.objects.settlement.update',
    [GARBAGE_TYPE_DEFENCE]: 'geo.objects.defense.update',
    [GARBAGE_TYPE_GARAGE]: 'geo.objects.garage.update',
    [GARBAGE_TYPE_INDIVIDUAL_AREA]: 'geo.objects.individualArea.update',
    [GARBAGE_TYPE_INDIVIDUAL]: 'geo.objects.individual.update',
    [GARBAGE_TYPE_LEGAL_ENTITY]: 'geo.objects.legalEntity.update',
    [GARBAGE_TYPE_MEDIC]: 'geo.objects.medic.update',
    [GARBAGE_TYPE_ORGANIZATION]: 'geo.objects.organization.update',
    [GARBAGE_TYPE_MKD]: 'geo.objects.apartmentBuildings.update'
  }
}

export const GARBAGE_TYPE_ROUTE_NAME_MAP = region.getRegionConfig(_GARBAGE_TYPE_ROUTE_NAME_MAP)

// geo.objects.operator.update

// used in map popup
export const ICON_TYPE_ROUTE_NAME_MAP = {
  def: 'geo.objects.defense.update',
  org: 'geo.objects.organization.update',
  med: 'geo.objects.medic.update',
  uk: 'geo.objects.manager.update',
  ind: 'geo.objects.individualArea.update',
  country: 'geo.objects.countryCommunity.update',
  gsk: 'geo.objects.garage.update',
  set: 'geo.objects.settlement.update',
  dep: 'geo.objects.deposits.update',
  fac: 'geo.objects.factories.update',
  pup: 'geo.objects.public_place.update',
  dor: 'geo.objects.dormitories.update',
  container: 'geo.objects.withContainer.update',
  noContainer: 'geo.objects.withoutContainer.update',
  separate: 'geo.objects.separate.update',
  thrash: 'geo.objects.heap.update',
  noThrash: 'geo.objects.unauth.update',
  process: 'geo.objects.object.update',
  util: 'geo.objects.object.update',
  neutral: 'geo.objects.object.update',
  storage: 'geo.objects.object.update',
  burial: 'geo.objects.object.update',
  transport: 'geo.objects.operator.update',
  // appeals
  unauth: 'citizen.appealsMap.update',
  schedule: 'citizen.appealsMap.update',
  bill: 'citizen.appealsMap.update',
  initiative: 'citizen.appealsMap.update',
  other: 'citizen.appealsMap.update',
  // regional
  individuals: 'geo.objects.individual.update',
  legalEntities: 'geo.objects.legalEntity.update',
  // krasn
  apartmentBuildings: 'geo.objects.apartmentBuildings.update'

}

// use in toolbar
export const ROUTE_NAME_LAYER_MAP = {
  'garbage.defenses': 'def',
  'garbage.organizations': 'org',
  'garbage.medics': 'med',
  'garbage.managers': 'uk',
  'garbage.individualAreas': 'ind',
  'garbage.countryCommunitys': 'country',
  'garbage.garages': 'gsk',
  'garbage.settlements': 'set',
  'garbage.deposits': 'dep',
  'garbage.factories': 'fac',
  'garbage.dormitories': 'dor',
  'msn.withContainers': 'container',
  'msn.withoutContainers': 'noContainer',
  'msn.separateCollections': 'separate',
  'unauthorized.heaps': 'heap',
  'unauthorized.wpf': 'unauth',
  'registry.operators': 'trans,transport',
  'registry.regionalOperators': 'trans,transport',
  'registry.objects': 'process,object,util,neutral,storage,burial',
  'citizen.appeals': 'appeal,unauth,schedule,bill,initiative,other',

  'garbage.legalEntities': 'legalEntities',
  'garbage.individuals': 'individuals',
  'garbage.apartmentBuildings': 'apartmentBuildings'
}

export const GOOGLE_MAP_KEY = 'AIzaSyAZYZWpaECgci01tE3XcIYE0AzpzR_1IN8'

export const SUPERCLASTER_MAP_SPIRAL_COEF = region.getRegionConfig({
  default: {k: 3.5, spiralLengthFactor: 4.5},
  [KRASN]: {k: 1.7, spiralLengthFactor: 5.2},
  [KAREL]: {k: 2.5, spiralLengthFactor: 4.0},
  [BURYATIA]: {k: 14.5, spiralLengthFactor: 14.0},
})

export const TREADS_POLY_STYLE = {
  fact: {
    color: '#4389fc',
    arrowSize: 7
  },
  planned: {
    color: '#4389fc',
    dashArray: '15, 15',
    dashOffset: 15,
    arrowSize: 7
  },
  removed: {
    color: '#696969',
    arrowSize: 7
  }
}

export const TREADS_POLY_SUBCOLOR = {
  tko: '#009933',
  other: '#1560BD',
  mixed: '#800080'
}

export const LOCALITY_POLY_OPTIONS = region.getRegionConfig({
  default: {
    color: 'rgba(0, 0, 0, 0.1)',
    weight: 2,
  },
  [KURGAN]: {
    color: 'rgba(0, 0, 0, 0.3)',
    weight: 2,
  }
})

export const CHANGE_HEAT_MAP_REG_OP_ON_ZOOM = region.getRegionConfig({
  default: 10,
  [KURSK]: 10,
  [PSCOV]: 15,
  [MARIEL]: 13
})
